import React, { Component } from 'react';
import Header from '../Component/Layout/Header';
export default function MarketingPanel() {
    return (

        <>
            <div class="app-content content"><a href="https://www.workctrl.tech/workctrl-free-trial-schedule/" target="_blank"><img class="img-fluid centerData" src="https://smartworks-production.s3.ap-southeast-1.amazonaws.com/assets/avabanner123456.png" /></a></div>
        </>
    );
}
